import { inject } from '@angular/core';
import { Routes } from '@angular/router';
import { AuthService } from '@services/auth/auth.service';
import { NotFoundComponent } from '@shared/pages/not-found/not-found.component';
import { PaymentRequiredComponent } from '@shared/pages/payment-required/payment-required.component';
import publicRoutes from './components/public/public.routes';

export const routes: Routes = [
	// Public enrollment funnel — no auth: prospective students arrive from the website.
	{
		path: 'matricula',
		title: 'Matricúlate ya en Grupo Studium Formación',
		loadChildren: () => import('./components/public/enrollment/enrollment.routes'),
	},
	// Public monitor registration form (RRHH recruitment) — no auth.
	{
		path: 'registro-monitor',
		title: 'Registro de monitor · Grupo Studium',
		loadComponent: () =>
			import('./components/public/monitor-registration/monitor-registration.component').then(
				(m) => m.MonitorRegistrationComponent,
			),
	},
	{
		path: 'registro-monitor/:token',
		title: 'Registro de monitor · Grupo Studium',
		loadComponent: () =>
			import('./components/public/monitor-registration/monitor-registration.component').then(
				(m) => m.MonitorRegistrationComponent,
			),
	},
	// Time-tracking kiosk for the tablets installed in the centers — no auth (device token).
	{
		path: 'fichaje',
		title: 'Fichaje · Grupo Studium',
		loadComponent: () => import('./components/public/kiosk/kiosk.component').then((m) => m.KioskComponent),
	},
	// Public payment link for pending-payment students (emailed from the ficha).
	{
		path: 'pagar/:ref',
		loadComponent: () => import('./components/public/pay-link/pay-link.component').then((m) => m.PayLinkComponent),
	},
	{
		path: '',
		children: publicRoutes,
	},
	{
		path: '',
		canMatch: [
			() => {
				const token = inject(AuthService).getToken();
				return !!token; // Allow all authenticated users
			},
		],
		loadChildren: () => import('./components/backoffice/backoffice.routes'),
	},
	{
		path: 'cuenta',
		canMatch: [
			() => {
				return !!inject(AuthService).getToken();
			},
		],
		loadChildren: () => import('./components/backoffice/account/account.routes'),
	},
	{
		path: 'pago-requerido',
		component: PaymentRequiredComponent,
	},
	{
		path: '**',
		component: NotFoundComponent,
	},
];
